var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{staticClass:"ir-module-block",attrs:{"loading":_setup.custom.loading,"empty":_setup.isEmpty}},[_vm._l((_setup.pageData),function(item,index){return _c(_setup.CCardSymbol,{key:index,attrs:{"item":item,"formatter":() => ({
				subject: item.subject,
				imageUrl: item.logoUrl,
				date: item.contentTime
			}),"moduleType":"custom"},on:{"click":function($event){return _setup.handleClick(item)}}})}),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }